import { render, staticRenderFns } from "./createPayout.vue?vue&type=template&id=5880700a&scoped=true&"
import script from "./createPayout.vue?vue&type=script&lang=js&"
export * from "./createPayout.vue?vue&type=script&lang=js&"
import style0 from "./createPayout.vue?vue&type=style&index=0&id=5880700a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880700a",
  null
  
)

export default component.exports